import { Box, Text, RadioGroup, Radio } from '@customerio/pluma-components/react';

interface ActionFilterProps {
  value: string;
  onChange: (value: string) => void;
  hasObjectType: boolean;
}

const ACTION_OPTIONS = [
  { label: 'Created', value: 'created' },
  { label: 'Updated', value: 'updated' },
  { label: 'Deleted', value: 'deleted' },
];

export const ActionFilter: React.FC<ActionFilterProps> = ({ value, onChange, hasObjectType }) => {
  return (
    <Box p="300">
      {!hasObjectType ? (
        <Text size="s" color="subtle">
          Select an Object Type to filter by change type.
        </Text>
      ) : (
        <RadioGroup value={value ?? ''} onChange={onChange} label="Action Options">
          {ACTION_OPTIONS.map((option) => (
            <Radio key={option.value} label={option.label} value={option.value} />
          ))}
        </RadioGroup>
      )}
    </Box>
  );
};
